"use strict";

angular.module("imagetrend.components").directive("hlpCheckboxes", [
    "$injector",
    "Format",
    "Validation",
    "$timeout",
    function ($injector, Format, Validation, $timeout) {
        return {
            restrict: "AE",
            scope: {
                ngModel: "=",
                question: "=?",
                name: "@?",
                id: "@?",
                showLabel: "@?",
                updateService: "@?",
                isRequired: "=?",
                showRequired: "=?",
                options: "=?",
                label: "@?",
                title: "@?",
                requiredText: "@?",
                instructions: "@?",
                classes: "@?",
                selectShow: "@?",
                selectValue: "@?",
                service: "@?",
                method: "@?",
                isDisabled: "=?",
                topLabel: "=?",
                modal: "@?",
                showColon: "=?",
                vertical: "=?",
                parameters: "=?",
                pdf: "=?",
                showValue: "=?",
                validation: "=?",
                requiredPositions: "=?",
                posIdx: "=?",
                completed: "=?",
                groups: "=?" // for service user affiliations (positions)
            },
            require: "ngModel",
            transclude: true,
            replace: true,
            templateUrl: "templates/checkboxes/checkboxes.html",
            controller: [
                "$scope",
                "$timeout",
                function ($scope, $timeout) {
                    $scope.additional_id = ($scope.question && $scope.question.group_id) ? $scope.question.group_id + ',' : '';
                    $scope.validate = function () {
                        if ($scope.validation) {
                            Validation.validateQuestion(
                                $scope.innerForm,
                                $scope.validation,
                                $scope.ngModel
                            ).then(function (result) {
                                if (
                                    $scope.question !== undefined &&
                                    $scope.question.answer !== undefined
                                ) {
                                    $scope.question.answer.invalid =
                                        !result ||
                                        !isEmpty($scope.innerForm.$error);
                                }
                            });
                        } else {
                            if (
                                $scope.question !== undefined &&
                                $scope.question.answer !== undefined
                            ) {
                                $scope.question.answer.invalid = !isEmpty(
                                    $scope.innerForm.$error
                                );
                            }
                        }
                    };
                    var validationTimeout = $timeout(function () {
                        if (!$scope.requiredText) {
                            $scope.requiredText =
                                "Please select a " +
                                Format.label($scope.label || "value");
                        }

                        if ($scope.innerForm !== undefined) {
                            if ($scope.isRequired) {
                                if (
                                    $scope.ngModel == null ||
                                    $scope.ngModel.length == 0
                                ) {
                                    $scope.innerForm.$setValidity(
                                        "required",
                                        false
                                    );
                                } else {
                                    $scope.innerForm.$setValidity(
                                        "required",
                                        true
                                    );
                                }
                            }
                            $scope.validate();
                        }
                    }, 0);

                    $scope.$on("$destroy", function () {
                        $timeout.cancel(validationTimeout);
                    });

                    if ($scope.question !== undefined && $scope.question.data_point_id === 'ba99ae16-280a-4fe5-9dd1-755e03733ded') { // service_users_position Data Point
                        // When options are updated, usually a user or service was change, update checkboxes as needed
                        $scope.$watch('options', function (newValue, oldValue) {
                            if ((newValue === null && oldValue === null)) { return; }

                            // case for multiple provider positions where full_position can be dropped
                            if (newValue && oldValue && typeof (newValue[0]) !== "string" && newValue[0].full_position === null && newValue.length === oldValue.length) {
                                for (var i = 0; i < newValue.length; i++) {
                                    newValue[i].full_position = oldValue[i].full_position;
                                }
                            }
                            if (newValue !== null && Array.isArray(newValue)) {
                                var groupsBool = $scope.groups && $scope.groups[0].component_allow_multiple_groups && $scope.groups[0].service_id !== null;
                                // List of answers & original answers to allow checkboxes to be re-toggled when position is full
                                $scope.answerList = [];
                                // multiple service users & position from service license
                                if (groupsBool) {
                                    for (var i = 0; i < $scope.groups.length; i++) {
                                        for (var j = 0; j < $scope.groups[i].questions.length; j++) {
                                            var currQuestion = $scope.groups[i].questions[j];
                                            // skip the question if it doesn't match the current checkbox question
                                            if (currQuestion.data_point_id !== 'ba99ae16-280a-4fe5-9dd1-755e03733ded') { continue; }

                                            // only check values on form in this instance
                                            if (currQuestion.answer.value !== null && currQuestion.answer.value !== undefined) {
                                                if (currQuestion.answer.value.includes(',')) {
                                                    $scope.answerList = $scope.answerList.concat(currQuestion.answer.value.split(','));
                                                } else {
                                                    $scope.answerList = $scope.answerList.concat(currQuestion.answer.value);
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    if ($scope.question.original_value !== null && $scope.question.original_value !== undefined) {
                                        if ($scope.question.original_value.includes(',')) {
                                            $scope.answerList = $scope.answerList.concat($scope.question.original_value.split(','));
                                        }
                                        else {
                                            $scope.answerList = $scope.answerList.concat($scope.question.original_value);
                                        }
                                    }
                                    if ($scope.question.answer.value !== null && $scope.question.answer.value !== undefined) {
                                        if ($scope.question.answer.value.includes(',')) {
                                            $scope.answerList = $scope.answerList.concat($scope.question.answer.value.split(','));
                                        }
                                        else {
                                            $scope.answerList = $scope.answerList.concat($scope.question.answer.value);
                                        }
                                    }
                                }

                                for (var i = 0; i < newValue.length; i++) {
                                    const option = newValue[i];
                                    var checkbox = document.getElementById($scope.additional_id + option.id + '_checkbox');

                                    if (checkbox !== null) {
                                        // Inside of () is a check for Service User/Service Affiliation Data Set (position)
                                        // allow a "Full" position to be re-checked if the position isn't full.
                                        var isFull = (groupsBool) ? (option.max && option.max <= $scope.answerList.filter(function (id) { return id === option.id; }).length) : option.full_position;

                                        // uncheck checkbox if needed and handle disabling
                                        if ((option.max === 0 || $scope.answerList.length === 0) && checkbox.checked === true && (groupsBool !== undefined && $scope.groups[0].component_data_set_code !== 'service_user_changes')) {
                                            checkbox.checked = false;
                                            $scope.ngModel = []; // needed for single position forms, switching users then checking a previous box held; then click any position, can cause some fields to lose data
                                            $scope.onChange(); // make sure model is updated when checkbox is unchecked, especially for the validation
                                        }

                                        if (groupsBool !== undefined && $scope.groups[0].component_data_set_code === 'service_user_changes') {
                                            checkbox.disabled = ($scope.isDisabled || !$scope.show(option)) ? true : false;
                                        }
                                        else if (groupsBool) {
                                            checkbox.disabled = $scope.isDisabled || !$scope.show(option) || option.max === 0 || (isFull && checkbox.checked !== true);
                                        }
                                        else {
                                            checkbox.disabled = $scope.isDisabled || !$scope.show(option) || ((($scope.answerList.indexOf(option.id) === -1 && option.checked !== true && option.full_position === 1 && isFull) || option.max === 0) && option.max !== null);
                                        }
                                    }
                                }
                            }
                        }, true);

                        // Only do this for non-preview
                        if ($scope.question.answer) {
                            // Value can sometimes be updated after options & ensure no double click needed
                            $scope.$watch('question.answer.value', function (newValue) {
                                if (newValue !== null && newValue.length !== 0) {
                                    var valueArr = newValue.includes(',') ? newValue.split(',') : newValue;

                                    if (typeof (valueArr) === 'string') { valueArr = [valueArr]; }

                                    valueArr.forEach(function (answer) {
                                        var checkbox = document.getElementById($scope.additional_id + answer + '_checkbox');
                                        if (checkbox !== null) {
                                            checkbox.checked = true;
                                            $scope.onChange();
                                        }
                                    });
                                }
                                else {
                                    // The checkboxes are cleared out from form-question.js when the service is changed
                                    // This is to make sure that clearing out actually takes affect
                                    $scope.ngModel = [];
                                    $scope.onChange();
                                }
                            }, true);
                        }
                    }
                }
            ],
            compile: function (elem, attrs) {
                return {
                    pre: function (scope, elem, attrs, ngModel) {
                        scope.timeouts = [];

                        if (!attrs.name) {
                            attrs.name = "checkboxes";
                        }
                        if (!attrs.id) {
                            attrs.id = attrs.name;
                        }
                        if (!attrs.label) {
                            attrs.label = Format.label(attrs.name);
                        }
                        if (!attrs.showLabel) {
                            attrs.showLabel = attrs.label.length > 0;
                        } else {
                            if (attrs.showLabel == "true") {
                                attrs.showLabel = true;
                            } else {
                                attrs.showLabel = false;
                            }
                        }
                        if (!attrs.topLabel) {
                            attrs.topLabel = false;
                        } else {
                            if (
                                attrs.topLabel == true ||
                                attrs.topLabel == "true"
                            ) {
                                attrs.topLabel = true;
                            } else {
                                attrs.topLabel = false;
                            }
                        }
                        if (!attrs.updateService) {
                            attrs.updateService = true;
                        } else {
                            if (
                                attrs.updateService == true ||
                                attrs.updateService == "true"
                            ) {
                                attrs.updateService = true;
                            } else {
                                attrs.updateService = false;
                            }
                        }
                        if (!attrs.showColon) {
                            attrs.showColon = true;
                        } else {
                            if (
                                attrs.showColon == true ||
                                attrs.showColon == "true"
                            ) {
                                attrs.showColon = true;
                            } else {
                                attrs.showColon = false;
                            }
                        }
                        //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                        if (!attrs.title) {
                            attrs.title = attrs.label;
                        }

                        if (!attrs.selectShow) {
                            attrs.selectShow = "name";
                        }
                        if (!attrs.selectValue) {
                            attrs.selectValue = "id";
                        }
                        if (!attrs.method) {
                            attrs.method = "get";
                        }
                        if (!attrs.modal) {
                            attrs.modal = false;
                        } else {
                            if (attrs.modal == "true") {
                                attrs.modal = true;
                            } else {
                                attrs.modal = false;
                            }
                        }
                        if (!attrs.forceString) {
                            attrs.forceString = false;
                        } else {
                            if (attrs.forceString == "true") {
                                attrs.forceString = true;
                            } else {
                                attrs.forceString = false;
                            }
                        }
                        if (!attrs.vertical) {
                            attrs.vertical = false;
                        } else {
                            if (attrs.vertical == "true") {
                                attrs.vertical = true;
                            } else {
                                attrs.vertical = false;
                            }
                        }

                        scope.optionsLoaded = false;
                        scope.dirOptions = [];
                        scope.getOptions = function () {
                            if (
                                scope.options != null &&
                                !(
                                    scope.service != null &&
                                    scope.service != "" &&
                                    scope.serviceOverride
                                )
                            ) {
                                if (
                                    Object.prototype.toString.call(
                                        scope.options
                                    ) !== "[object Array]"
                                ) {
                                    scope.options
                                        .split(",")
                                        .forEach(function (option) {
                                            scope.dirOptions.push({
                                                id: option.trim(),
                                                name: option.trim()
                                            });
                                        });
                                    scope.optionsLoaded = true;
                                } else {
                                    scope.$evalAsync(function () {
                                        scope.dirOptions = scope.options;
                                        scope.optionsLoaded = true;
                                    });
                                }
                            } else if (
                                scope.service != null &&
                                scope.service != ""
                            ) {
                                var groupIdx = -1;
                                if (scope.groups) {
                                    for (var i = 0; i < scope.groups.length; i++) {
                                        if (scope.groups[i].id === scope.question.group_id) {
                                            groupIdx = i;
                                            break;
                                        }
                                    };
                                }

                                const sUserPositionLogic = groupIdx > -1 && scope.groups && scope.groups[groupIdx] && scope.groups[groupIdx].component_data_set_code === 'service_users' && !scope.groups[groupIdx].submitted;
                                const affilPositionLogic = groupIdx > -1 && scope.groups && scope.groups[groupIdx] && scope.groups[groupIdx].component_data_set_code === 'user_services' && !scope.groups[groupIdx].submitted;
                                const editBool = (sUserPositionLogic || affilPositionLogic) && scope.groups[groupIdx] && (scope.groups[groupIdx].edit === true || scope.groups[groupIdx].component_allow_multiple_groups === false);
                                // if ( editing || viewing a completed form || form builder || non-position questions )
                                if (editBool || scope.completed || scope.ngModel === undefined || scope.posIdx === undefined || scope.groups[groupIdx].component_data_set_code === 'service_user_changes') {
                                    var service = $injector.get(scope.service);
                                    service[scope.method](scope.parameters).then(
                                        function (data) {

                                            scope.dirOptions = data;
                                            if (attrs.updateService) {
                                                scope.options = data;
                                            }
                                            scope.optionsLoaded = true;
                                        }
                                    );
                                }
                            } else {
                                scope.optionsLoaded = true;
                            }
                        };
                        scope.getOptions();

                        // watch for signal to refresh the options
                        scope.$watch(
                            "question.refreshOptions",
                            function (refresh) {
                                if (scope.question !== undefined) {
                                    if (
                                        refresh !== undefined &&
                                        refresh !== null &&
                                        refresh.length &&
                                        (scope.service != null &&
                                            scope.service.length)
                                    ) {
                                        scope.parameters.limit_position_ids = refresh;
                                        scope.optionsLoaded = false;
                                        scope.getOptions();
                                    }
                                    scope.question.refreshOptions = null;
                                }
                            },
                            true
                        );

                        // watch for signal to refresh the validation
                        if (
                            scope.question !== undefined &&
                            scope.question.data_point_code ==
                            "service_users_position"
                        ) {
                            scope.$watch(
                                "question.refreshValidation",
                                function (refresh) {
                                    scope.timeouts.push(
                                        $timeout(function () {
                                            if (
                                                refresh !== undefined &&
                                                refresh !== null &&
                                                refresh.length
                                            ) {
                                                Validation.validateQuestion(
                                                    scope.innerForm,
                                                    scope.validation,
                                                    scope.ngModel
                                                ).then(function (result) {
                                                    if (
                                                        scope.question !==
                                                        undefined &&
                                                        scope.question
                                                            .answer !==
                                                        undefined
                                                    ) {
                                                        scope.question.answer.invalid =
                                                            !result ||
                                                            !isEmpty(
                                                                scope.innerForm
                                                                    .$error
                                                            );
                                                    }
                                                });
                                            }
                                            scope.question.refreshValidation = null;
                                        }, 0)
                                    );
                                },
                                true
                            );
                        }

                        // watch if options is coming from an array that hasn't been set yet
                        scope.$watch("options", function (options) {
                            if (
                                options != null &&
                                scope.optionsLoaded &&
                                scope.service == null
                            ) {
                                scope.optionsLoaded = false;
                                scope.dirOptions = [];

                                if (
                                    Object.prototype.toString.call(
                                        scope.options
                                    ) !== "[object Array]"
                                ) {
                                    scope.options
                                        .split(",")
                                        .forEach(function (option) {
                                            scope.dirOptions.push({
                                                id: option.trim(),
                                                name: option.trim()
                                            });
                                        });
                                } else {
                                    scope.dirOptions = scope.options;
                                }
                                scope.optionsLoaded = true;
                            }
                        });

                        scope.$watch("optionsLoaded", function (optionsLoaded) {
                            if (optionsLoaded && scope.showValue == null) {
                                scope.dirOptions.forEach(function (opt) {
                                    opt.checked = false;
                                });
                                if (scope.showValue == null) {
                                    scope.setShowValue();
                                }
                            }
                            scope.timeouts.push(
                                $timeout(function () {
                                    if (
                                        scope.isRequired &&
                                        scope.innerForm !== undefined
                                    ) {
                                        if (
                                            ngModel.$modelValue == null ||
                                            ngModel.$modelValue.length == 0
                                        ) {
                                            scope.innerForm.$setValidity(
                                                "required",
                                                false
                                            );
                                        } else {
                                            scope.innerForm.$setValidity(
                                                "required",
                                                true
                                            );
                                        }
                                    }
                                    if (scope.question !== undefined) {
                                        scope.question.refreshValidation = true;
                                    }
                                }, 0)
                            );

                            // validate questions on options loaded - allows maxed positions to be disabled
                            if (scope.validation) {
                                Validation.validateQuestion(
                                    scope.innerForm,
                                    scope.validation,
                                    ngModel.$modelValue
                                ).then(function (result) {
                                    if (
                                        scope.question !== undefined &&
                                        scope.question.answer !== undefined
                                    ) {
                                        scope.question.answer.invalid =
                                            !result ||
                                            !isEmpty(scope.innerForm.$error);
                                    }
                                });
                            }
                        });

                        scope.setShowValue = function () {
                            if (
                                ngModel.$modelValue != null &&
                                scope.dirOptions != null
                            ) {
                                scope.showValue = generateStringFromArrays(
                                    ngModel.$modelValue,
                                    scope.dirOptions
                                );
                            }
                        };

                        // see if this needs to be wrapped in a $timeout
                        ngModel.$render = function () {
                            if (ngModel.$modelValue != null) {
                                if (
                                    scope.showValue == null &&
                                    scope.optionsLoaded
                                ) {
                                    scope.setShowValue();
                                }
                            }

                            if (scope.validation) {
                                Validation.validateQuestion(
                                    scope.innerForm,
                                    scope.validation,
                                    ngModel.$modelValue
                                );
                            }
                        };

                        scope.show = function (item) {
                            return (
                                typeof item.hide == "undefined" ||
                                item.hide == null ||
                                item.hide == false ||
                                item.checked != false
                            );
                        };
                        scope.getTitle = function (item) {
                            return scope.show(item)
                                ? scope.title
                                : "Maximum number of positions reached";
                        };

                        scope.onChange = function () {
                            scope.submitted = false;
                            scope.processingChange = true;
                            scope.timeouts.push(
                                $timeout(function () {
                                    scope.setShowValue();
                                    if (scope.isRequired) {
                                        if (
                                            ngModel.$modelValue == null ||
                                            ngModel.$modelValue.length == 0
                                        ) {
                                            scope.innerForm.$setValidity(
                                                "required",
                                                false
                                            );
                                        } else {
                                            scope.innerForm.$setValidity(
                                                "required",
                                                true
                                            );
                                        }
                                    }
                                    if (scope.validation) {
                                        Validation.validateQuestion(
                                            scope.innerForm,
                                            scope.validation,
                                            ngModel.$modelValue
                                        ).then(function (result) {
                                            if (
                                                scope.question !== undefined &&
                                                scope.question.answer !==
                                                undefined
                                            ) {
                                                scope.question.answer.invalid =
                                                    !result ||
                                                    !isEmpty(
                                                        scope.innerForm.$error
                                                    );
                                            }
                                        });
                                    }

                                    scope.processingChange = false;
                                }, 0)
                            );
                        };

                        scope.submitted = false;
                        scope.$on("form:submit", function () {
                            scope.validate();
                            scope.submitted = true;
                        });

                        scope.$on("$destroy", function () {
                            scope.timeouts.forEach(function (timer) {
                                $timeout.cancel(timer);
                            });
                        });
                    }
                };
            }
        };
    }
]);
